import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";

export function StaffSetupGuide() {
  return (
    <Card className="mb-6 border-primary/20 bg-primary/5" data-testid="staff-setup-guide">
      <CardHeader>
        <CardTitle className="text-lg">Create a staff user (pages only)</CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-3 text-muted-foreground">
        <ol className="list-decimal list-inside space-y-2">
          <li>Sign in here as <strong>admin</strong> and turn <strong>Admin mode ON</strong>.</li>
          <li>Open the <strong>Users</strong> tab → <strong>Add User</strong>.</li>
          <li>Set <strong>Role</strong> to <code>staff (pages only)</code>, email, and password (min 8 chars).</li>
          <li>Click <strong>Create user</strong>. Staff cannot edit Sacred Library or publish directly.</li>
        </ol>
        <p>
          Staff sign in at <Link to="/admin/sacred" className="text-primary underline">/admin/sacred</Link>, then edit at{" "}
          <Link to="/admin/pages" className="text-primary underline">/admin/pages</Link>. They use{" "}
          <strong>Submit for approval</strong>; you approve under <strong>Approvals</strong>.
        </p>
        <p className="text-xs">
          If you see <strong>Bootstrap required</strong>, finish one-time setup at{" "}
          <Link to="/admin/setup" className="underline">/admin/setup</Link> (Worker secret{" "}
          <code>ADMIN_API_KEY</code>), then sign in here — you do not need the API key in the form after login.
        </p>
      </CardContent>
    </Card>
  );
}
